import { Button, Stack, Typography } from "@mui/material";
import { useGetCampaignSummaryQuery } from "../../../api";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { FileListItem } from "./FileListItem";
import { LinkListItem } from "./LinkListItem";
import { CIDType } from "../../../types/apiTypes";

type Props = CIDType & {
  index: number;
};

const CidItem = ({
  cid,
  hg_data: { hg_file_names, hg_file_links },
  index,
}: Props) => {
  return (
    <Stack gap="8px">
      <Typography variant="subtitle1" sx={{ color: "#464646" }}>
        CID {index} : {cid}
      </Typography>
      {hg_file_names.map((fileName) => (
        <FileListItem key={cid + fileName} fileName={fileName} />
      ))}
      {hg_file_links.map((fileName) => (
        <LinkListItem key={cid + fileName} url={fileName} />
      ))}
    </Stack>
  );
};

export const HgInsightsBlock = () => {
  const { campaign_id } = useParams();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const { data: summary } = useGetCampaignSummaryQuery({
    campaign_id: campaign_id!,
  });

  if (!summary?.crm?.lead_tools_cids) return null;

  const hgList = summary.crm.lead_tools_cids.filter(({ hg_data }) => hg_data);

  if (hgList.length === 0) return null;
  return (
    <Stack>
      <Stack gap="8px">
        <Typography
          variant="subtitle1"
          color="custom.textDarkBlue"
          sx={{ fontWeight: 500 }}
        >
          HG Insights
        </Typography>
        <CidItem
          cid={hgList[0].cid}
          hg_data={hgList[0].hg_data}
          index={1}
          sub_cids={[]}
        />
        {isExpanded &&
          hgList
            .slice(1)
            .map(({ cid, hg_data }, index) => (
              <CidItem
                key={cid + index}
                cid={cid}
                hg_data={hg_data}
                index={index + 2}
                sub_cids={[]}
              />
            ))}
      </Stack>
      {hgList.length > 1 && (
        <Button
          variant="text"
          sx={{
            maxWidth: "fit-content",
            color: "#1C3C6C",
            "&:hover": {
              backgroundColor: "#F1F1F1",
            },
            height: "36px",
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Show Less" : "Show More"}
        </Button>
      )}
    </Stack>
  );
};
